module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Event",
      "items": _vm.eventsList
    },
    model: {
      value: (_vm.itemData.events_id),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "events_id", $$v)
      },
      expression: "itemData.events_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": _vm.notificationTypesList
    },
    model: {
      value: (_vm.itemData.vendor),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "vendor", $$v)
      },
      expression: "itemData.vendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', [(_vm.itemData.vendor === 'email') ? _c('v-text-field', {
    attrs: {
      "outline": "",
      "label": "Subject"
    },
    model: {
      value: (_vm.itemData.subject),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "subject", $$v)
      },
      expression: "itemData.subject"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Message"
    },
    model: {
      value: (_vm.itemData.message),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "message", $$v)
      },
      expression: "itemData.message"
    }
  })], 1), _vm._v(" "), (!_vm.isLeadAddedEvent) ? _c('v-flex', {
    staticClass: "text-md-left"
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$case_id!!}')
      }
    }
  }, [_vm._v("Case ID")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$case_name!!}')
      }
    }
  }, [_vm._v("Case name")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$client_salutation!!}')
      }
    }
  }, [_vm._v("Client salutation")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$client_name!!}')
      }
    }
  }, [_vm._v("Client name")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$quotation_link!!}')
      }
    }
  }, [_vm._v("Quotation link")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$agreement_link!!}')
      }
    }
  }, [_vm._v("Agreement link")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$date_time_of_funerals!!}')
      }
    }
  }, [_vm._v("Date time of funerals")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$amount_of_days!!}')
      }
    }
  }, [_vm._v("Amount of days")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$location!!}')
      }
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_package!!}')
      }
    }
  }, [_vm._v("Selected Package")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_casket!!}')
      }
    }
  }, [_vm._v("Selected Casket")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_products!!}')
      }
    }
  }, [_vm._v("Selected Products")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_products_list_text!!}')
      }
    }
  }, [_vm._v("Selected Products-Amount List Text")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', [_c('v-combobox', {
    attrs: {
      "label": "Recipients",
      "items": _vm.notificationRecipients,
      "item-value": "id",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_vm._v("\n            " + _vm._s(!_vm.isEmailType ? data.item.email : data.item.phone) + "\n          ")]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_vm._v("\n            " + _vm._s(!_vm.isEmailType ? data.item.email : data.item.phone) + "\n          ")]
      }
    }]),
    model: {
      value: (_vm.selectedRecipients),
      callback: function($$v) {
        _vm.selectedRecipients = $$v
      },
      expression: "selectedRecipients"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.roles,
      "label": "Roles",
      "multiple": ""
    },
    model: {
      value: (_vm.selectedRoles),
      callback: function($$v) {
        _vm.selectedRoles = $$v
      },
      expression: "selectedRoles"
    }
  })], 1), _vm._v(" "), (!_vm.isLeadAddedEvent) ? _c('v-flex', [_c('v-checkbox', {
    attrs: {
      "label": "Send to case Client?"
    },
    model: {
      value: (_vm.itemData.send_to_client),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "send_to_client", $$v)
      },
      expression: "itemData.send_to_client"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', [_c('v-checkbox', {
    attrs: {
      "label": "Is active"
    },
    model: {
      value: (_vm.itemData.is_active),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "is_active", $$v)
      },
      expression: "itemData.is_active"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": [function($event) {
        return _vm.clearDialogForm()
      }, function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }]
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73e3239d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/AppEditNotificationsDialog.vue
// module id = 1008
// module chunks = 1